export enum ResultType {
    WON = 'WON',
    LOST = 'LOST',
    TIE = 'TIE',
    TECH_LOSS = 'TECH_LOSS',
}
